import { render } from "./ModalBlocking.vue?vue&type=template&id=566fabb4"
import script from "./ModalBlocking.vue?vue&type=script&lang=ts"
export * from "./ModalBlocking.vue?vue&type=script&lang=ts"
script.render = render

export default script